import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;

  h2 {
    margin-bottom: 1rem;
    color: black;
    font-weight: 600;
  }

  div {
    display: flex;
    align-items: center;
    div {
      min-width: 9rem;
    }

    @media (max-width: 900px) {
      flex-direction: column;
      align-items: flex-start;
      grid-row-gap: 1rem;
      & > * {
        margin-right: 0;
      }
    }
  }
`;

type Props = {
  title: string;
};
const TitleList: FC<Props> = ({ title, children }) => {
  return (
    <Container>
      <h2>{title}</h2>
      {children}
    </Container>
  );
};

export default TitleList;
